import { render, staticRenderFns } from "./os-tabs.vue?vue&type=template&id=7ee01617&scoped=true&"
import script from "./os-tabs.vue?vue&type=script&setup=true&lang=js&"
export * from "./os-tabs.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./os-tabs.vue?vue&type=style&index=0&id=7ee01617&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ee01617",
  null
  
)

export default component.exports